import React from "react"
import styled from "styled-components"
import Img from "gatsby-image"
import { Link } from "gatsby"
import Section from "../elements/Section"
import Container from "../elements/Container"
import Title, {TitleH2} from "../elements/Title"
import globalVariables from "../globalVariables"
import ButtonPlus from "../elements/Button/ButtonPlus"

const Wrapper = styled.div`
  text-align: center;
  @media (max-width: ${globalVariables.maxMobile}) {
    .title1 {
      margin-top: 10px;
      margin-bottom: 50px;
    }
  }
  @media (min-width: ${globalVariables.minTablet}) {
    max-width: 910px;
    margin: auto;
    .title1 {
      margin-bottom: 75px;
      margin-top: 5px;
    }
  }
`

const Row = styled(Link)`
  display: flex;
  flex-direction: column;
  box-shadow: 0 8px 10px 0 rgba(81, 85, 93, 0.08);
  margin-bottom: 20px;
  text-decoration: none;
  @media (min-width: ${globalVariables.minTablet}) {
    height: 145px;
    flex-direction: row;
    align-items: center;
    &:hover .title2 {
      color: ${props => props.theme.primary};
    }
  }
`

const CardImage = styled.div`
  height: 200px;
  width: 100%;
  @media (min-width: ${globalVariables.minTablet}) {
    height: 100%;
    flex: 0 0 235px;
  }
`

const CardContent = styled.div`
  background: white;
  height: 100%;
  width: 100%;
  display: flex;
  flex-direction: row;
  justify-content: space-between;
  align-items: center;
  position: relative;
  @media (max-width: ${globalVariables.maxMobile}) {
    .title2 {
      padding: 10px;
      text-align: center;
    }
  }

  @media (min-width: ${globalVariables.minTablet}) {
    padding: 0 70px;
  }
  @media (max-width: ${globalVariables.maxMobile}) {
    min-height: 150px;
    button {
      display: none;
    }
  }
`

const Contrat = styled.div`
  width: 74px;
  height: 74px;
  background: ${props => props.theme.greyLighter};
  border-radius: 50%;
  display: flex;
  flex-direction: column;
  justify-content: center;
  align-items: center;
  position: absolute;
  top: -37px;
  left: 50%;
  transform: translateX(-50%);
  span {
    color: ${props => props.theme.primary};
    font-size: 20px;
    font-weight: bold;
    text-transform: uppercase;
  }
  @media (min-width: ${globalVariables.minTablet}) {
    top: 50%;
    left: -37px;
    transform: translateY(-50%);
  }
`

export const OffreCard = ({ item }) => (
  <Row to={item.node.path}>
    <CardImage>
      <Img
        fluid={item.node.acf.image_banniere.localFile.childImageSharp.fluid}
      />
    </CardImage>
    <CardContent>
      <Contrat>
        <span>{item.node.acf.contrat_banniere}</span>
      </Contrat>
      <Title className="title2" margin="0">
        {item.node.acf.titre_banniere}
      </Title>
      <ButtonPlus />
    </CardContent>
  </Row>
)

const Offres = ({ title, items }) => {
  const publishedItems = () => {
    return items.filter(
      item => item.node.acf.statut_de_publication === "Publié"
    )
  }

  return (
    <Section color="greyLighter" border id="offres">
      <Container>
        <Wrapper>
          <TitleH2 className="title1">{title}</TitleH2>
          {publishedItems().length > 0 ? (
            publishedItems().map((item, index) => (
              <OffreCard key={index} item={item} />
            ))
          ) : (
            <p>Nous n'avons pas d'offres d'emploi pour le moment.</p>
          )}
        </Wrapper>
      </Container>
    </Section>
  )
}

export default Offres
